import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IconSend } from "@tabler/icons-react";
import { useUpdateData } from "hooks/useApiHooks";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { usePhotographer } from "../../context/PhotographerContext";
// import { usePhotographer } from "contexts/v1/masterData/PhotographerContext";

const UpdatePhotographer = ({ initialData, refetch, onSuccess, onError }) => {
  const API_URL = "/reservation/change-photographer";
  const { photographers } = usePhotographer();

  // **Konversi photographer ke format select option**
  const photographerOptions =
    photographers?.data?.map((photographer) => ({
      value: photographer.id,
      label: photographer.name,
    })) || [];

  // **Ambil photographer yang sudah dipilih dari initialData**
  const initialSelectedPhotographers =
    initialData?.photographers?.map((photographer) => ({
      value: photographer.id,
      label: photographer.name,
    })) || [];

  // **State untuk menyimpan data photographer yang dipilih**
  const [selectedPhotographers, setSelectedPhotographers] = useState(initialSelectedPhotographers);

  const { updateData: updatePhotographer } = useUpdateData(API_URL);
  const { handleSuccessToast, handleError } = useCanvasHandler();

  // **Handle perubahan pada multi-select**
  const handlePhotographerChange = (selectedOptions) => {
    setSelectedPhotographers(selectedOptions || []); // Simpan data baru
  };

  // **Submit data ke API**
  const handleSubmit = async () => {
    if (selectedPhotographers.length === 0) {
      handleError("Pilih minimal satu photographer!");
      return;
    }

    const payload = {
      reservation_ids: [initialData.id], // **Tambahkan reservation_id**
      photographer_ids: selectedPhotographers.map((photographer) => photographer.value), // **Ambil ID dari photographer yang dipilih**
    };

    try {
      await updatePhotographer(payload);
      // handleSuccessToast("Photographers updated successfully");
      if (typeof onSuccess === "function") onSuccess();
      if (typeof refetch === "function") refetch();
    } catch (error) {
      console.error("Error updating photographers:", error);
      handleError("Failed to update photographers.");
      if (typeof onError === "function") onError();
    }
  };

  // **Update selectedPhotographers saat `initialData` berubah**
  useEffect(() => {
    if (initialData?.photographers) {
      setSelectedPhotographers(
        initialData.photographers.map((photographer) => ({
          value: photographer.id,
          label: photographer.name,
        }))
      );
    }
  }, [initialData]);

  return (
    <form className="d-flex flex-column" style={{ height: "100%" }}>
      <div className="action-sheet-content flex-grow-1">
        <div className="form-group mb-3">
          <label htmlFor="photographer" className="form-label">
            Pilih Photographer
          </label>
          <Select
            options={photographerOptions}
            value={selectedPhotographers} // **Tampilkan photographer yang sudah dipilih**
            onChange={handlePhotographerChange} // ✅ Multi-select handler
            isMulti={true} // ✅ Aktifkan multi select
            isClearable
            placeholder="Pilih Photographer"
            // menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 1050 }) }}
          />
        </div>
      </div>

      {/* 🔥 Tombol Submit */}
      <div className="d-flex justify-content-end mt-0">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          Update Photographer <IconSend className="ms-2" size={20} />
        </button>
      </div>
    </form>
  );
};

export default UpdatePhotographer;
